import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomerDto } from '../../dtos';
import { useFailedCreateSnackbar, useSuccessfulCreateSnackbar } from '../../Components/CoreLib/library';
import { useCreateCustomerMutation } from '../../store/generated/generatedApi';
import { CustomerFullPageForm } from '../../Components/Forms/CustomerForm';

export const AddCustomerView: FC = () => {
    const navigate = useNavigate();
    const [createCustomer, { data, isError, isSuccess, reset }] = useCreateCustomerMutation();

    useSuccessfulCreateSnackbar('Customer', isSuccess, () => navigate(`/customer/${data?.id}`));
    useFailedCreateSnackbar('customer', isError, reset)

    const handleSave = (values: CustomerDto) => {
        createCustomer(values);
    };

    const handleCancel = () => {
        navigate('/customers');
    };

    return <CustomerFullPageForm save={handleSave} cancel={handleCancel} />;
};
